import { OnlineSales } from 'gw-edge-client';
import type { InsuranceCompanyDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/insurancecompany/dto';
import { selector } from 'recoil';

export const insuranceCompaniesSelector = selector<InsuranceCompanyDTO[]>({
    key: 'insuranceCompaniesSelector',
    get: async () => {
        return await OnlineSales.getAllInsuranceCompanies();
    }
});
